<template>
  <div data-v-sticky-container style="padding-top: 60px">
    <transition name="slide-fade">
      <div class="landingPage-loading" v-if="!isLoading">
          <div class="landingPage-loading__logo">
            <img src="../assets/images/logo.png" alt="Toyota logo" width="120px" height="40px" />
          </div>
          <div class="landingPage-loading__three-bounce">
            <div class="landingPage-loading__three-bounce__one"></div>
            <div class="landingPage-loading__three-bounce__two"></div>
            <div class="landingPage-loading__three-bounce__three"></div>
          </div>
        <!-- <div class="landingPage-loading__chase">
          <div class="landingPage-loading__dot"></div>
          <div class="landingPage-loading__dot"></div>
          <div class="landingPage-loading__dot"></div>
          <div class="landingPage-loading__dot"></div>
          <div class="landingPage-loading__dot"></div>
          <div class="landingPage-loading__dot"></div>
        </div> -->
      </div>
    </transition>
    <!-- #Header -->
    <div id="header" v-sticky="stickyOption">
      <div class="container">
        <div class="row" >
          <a id="logo" href="javascript:void(0)" class="col-6 col-md-2 align-self-center">
            <img src="../assets/images/logo.png" alt="Toyota logo" width="120px" height="40px" />
          </a>
          <div class="col-6 col-md-7 align-self-center d-none d-lg-block">
            <ul id="main-nav" class="nav float-right">
              <li class="nav-item align-self-center" v-if="homePaymentGuide && homePaymentGuide.MasterTitle">
                <a class="nav-link" href="#homePaymentGuide" v-scroll-to="{el: '#homePaymentGuide', offset: -130}">{{homePaymentGuide.MasterTitle}}</a>
              </li>
              <li class="nav-item align-self-center" v-if="homeQAInformationData && homeQAInformationData.MasterTitle">
                <a class="nav-link" href="#homeQAInformationData" v-scroll-to="{el: '#homeQAInformationData', offset: -130}">{{homeQAInformationData.MasterTitle}}</a>
              </li>
              <li class="nav-item align-self-center" v-if="homeProductInfo && homeProductInfo.MasterTitle">
                <a class="nav-link" href="#homeProductInfo" v-scroll-to="{el: '#homeProductInfo', offset: -130}">{{homeProductInfo.MasterTitle}}</a>
              </li>
            </ul>
          </div>
          <div class="col-6 col-md-10 col-lg-3 d-flex align-items-center justify-content-end text-right">
            <b-dropdown id="dropdown-language" variant="default" class="m-2">
              <template v-slot:button-content><flag :iso="languages[$i18n.locale].find(language => language.language === $i18n.locale).flag" /></template>
              <b-dropdown-item href="#" v-for="(language, index) in languages[$i18n.locale]" :key="index" @click="changeLocale(language.language)"><flag :iso="language.flag" />{{language.title}}</b-dropdown-item>
            </b-dropdown>
            <router-link id="btn-login" class="btn btn-danger text-nowrap" style="min-width: 150px;" :to="{ name: 'login'}">{{$t('header.login')}}</router-link>
          </div>
        </div>
      </div>
      <div data-v-sticky-inner></div>
    </div>
    <!-- #Wrapper -->
    <div id="wrapper" class="container-fluid">
      <div class="homeSection__wrapper">
        <section class="homeSection" v-if="homeSlide">
          <b-modal v-for="(slide, index) in homeSlide" :key="index" :id="'homeSlide-'+index" size="lg" header-bg-variant="danger" centered header-text-variant="white" :title="slide.Title" scrollable>
            <div v-html="slide.Content"></div>
            <template v-slot:modal-footer="{ ok }">
              <b-button size="lg" variant="danger" @click="ok()" block>OK</b-button>
            </template>
          </b-modal>
          <slick
            ref="homeSlideSlick"
            :options="homeSlideSlickOptions"
            @reInit="homeSlideSlickHandleReInit">
            <div v-for="(slide, index) in homeSlide" :key="index">
              <b-link v-b-modal="'homeSlide-'+index">
                <img class="forPC" :src="slide.ImageDesktopBase64" alt="">
                <img class="forSP" :src="slide.ImageMobileBase64" alt="">
              </b-link>
            </div>
          </slick>
        </section>
        <section id="homeBenefit" class="homeSection" v-if="homeBenefit">
          <h2 class="homeSection__heading homeProductInfo__heading" v-if="homeBenefit.MasterTitle">{{homeBenefit.MasterTitle}}</h2>
          <div class="homeSection__content homeBenefit__content">
            <div class="homeBenefit__description" v-if="homeBenefit.Content" v-html="homeBenefit.Content"></div>
            <div class="homeBenefit__video" v-if="homeBenefit.listVideo"
                @mouseover="() => {
                  if (!homeBenefitHoverFlag) {
                    homeBenefitHoverFlag = true
                    homeBenefitHoverActive = true
                  }
                }"
                @mouseleave="() => {
                  homeBenefitHoverActive = false
                  homeBenefitHoverFlag = false
                }" >
              <!-- Video -->
              <div class="homeBenefit__video__main">
                <youtube :video-id="homeBenefitCurrentVideoID" ref="youtube" @playing="ybClickHandle" @paused="ybClickHandle" @ended="ybEndedHandle"></youtube>
              </div>
              <!-- swiper Thumbs -->
              <swiper class="swiper homeBenefit__video__thumb" :class="{active: homeBenefitHoverActive}" ref="swiperThumbs" :options="swiperOptionThumbs" @click-slide="homeBenefitClickHandle">
                <div class="homeBenefit__video__thumb__close" @click="homeBenefitHoverActive = false">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 493.456 493.456" style="enable-background:new 0 0 493.456 493.456;" xml:space="preserve"> <g> <g> <path d="M246.73,0C110.682,0,0.002,110.684,0.002,246.744c0,136.032,110.68,246.712,246.728,246.712    s246.724-110.68,246.724-246.712C493.454,110.684,382.778,0,246.73,0z M360.258,348.776l-11.112,11.12    c-2.808,2.836-7.82,2.836-10.644,0l-88.68-88.672c-0.728-0.74-1.704-1.136-2.732-1.136c-1.028,0-2.004,0.4-2.732,1.136    L155.682,359.9c-2.82,2.836-7.828,2.836-10.648,0l-11.108-11.12c-1.412-1.404-2.196-3.304-2.196-5.3    c0-2.02,0.784-3.916,2.196-5.344l88.68-88.672c1.508-1.512,1.508-3.948,0-5.452l-88.68-88.68c-1.412-1.416-2.196-3.308-2.196-5.32    c0-2.02,0.784-3.916,2.196-5.328l11.108-11.108c2.82-2.82,7.828-2.82,10.648,0l88.68,88.672c1.444,1.444,4.016,1.444,5.46,0    l88.676-88.676c2.824-2.824,7.836-2.824,10.644,0l11.112,11.112c2.928,2.924,2.928,7.716,0,10.648l-88.692,88.676    c-1.504,1.504-1.504,3.94,0,5.452l88.696,88.672C363.186,341.072,363.186,345.844,360.258,348.776z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>
                </div>
                <swiper-slide v-for="(video, index) in homeBenefit.listVideo" :key="index">
                  <img :src="'https://img.youtube.com/vi/'+getVideoId(video.VideoPath)+'/hqdefault.jpg'" v-if="video.VideoPath"/>
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </section>
        <section id="homePaymentGuide" class="homeSection" v-if="homePaymentGuide">
          <h2 class="homeSection__heading homePaymentGuide__heading" v-if="homePaymentGuide.MasterTitle">{{homePaymentGuide.MasterTitle}}</h2>
          <div class="homeSection__content">
            <b-tabs no-fade nav-class="homePaymentGuide__tabs" class="homePaymentGuide" content-class="homePaymentGuide__tab-content" v-if="homePaymentGuide.Content">
              <b-tab title-item-class="homePaymentGuide__tab" title-link-class="homePaymentGuide__nav-link" v-for="(paymentGuide, index) in homePaymentGuide.Content" :key="index" :active="index === 0">
                <template v-slot:title>
                  <div class="homePaymentGuide__icon">
                    <img :src="paymentGuide.Icon" alt="">
                  </div>
                  <h4 class="homePaymentGuide__title">{{paymentGuide.Title}}</h4>
                  </template>
                <div v-html="paymentGuide.Content"></div>
                <div class="homePaymentGuide__video-wrapper" v-if="paymentGuide.VideoPath">
                  <div class="homePaymentGuide__video">
                    <video width="100%" height="auto" :poster="paymentGuide.Thumbnail" controls>
                      <source :src="paymentGuide.VideoPath" type="video/mp4">
                      Your browser does not support the video tag.
                    </video>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
            <div v-if="homePaymentGuide.Content" class="homePaymentGuideSP">
              <div class="homePaymentGuideSP__item" v-for="(paymentGuide, index) in homePaymentGuide.Content" :key="index">
                <a class="homePaymentGuideSP__header" v-b-toggle="'collapse-' + index">
                  <div class="homePaymentGuideSP__icon">
                    <img :src="paymentGuide.Icon" alt="">
                  </div>
                  <h4 class="homePaymentGuideSP__title">{{paymentGuide.Title}}</h4>
                  <span class="d-flex justify-content-center align-items-center mt-2 ml-auto mr-auto read-more">{{$t('viewDetails')}}</span>
                </a>
                <b-collapse :id="'collapse-' + index" class="homePaymentGuideSP__content">
                  <div v-html="paymentGuide.Content"></div>
                  <div class="homePaymentGuide__video" v-if="paymentGuide.VideoPath">
                    <video width="100%" height="auto" :poster="paymentGuide.Thumbnail" controls>
                      <source :src="paymentGuide.VideoPath" type="video/mp4">
                      Your browser does not support the video tag.
                    </video>
                  </div>
                </b-collapse>
              </div>
            </div>
          </div>
        </section>
        <section id="homeQAInformationData" class="homeSection" v-if="homeQAInformationData">
          <h2 class="homeSection__heading homePaymentGuide__heading" v-if="homeQAInformationData.MasterTitle">{{homeQAInformationData.MasterTitle}}</h2>
          <div class="homeSection__content" v-if="homeQAInformationData.QAList">
            <div class="row qaqs-row question-item" v-for="(QAInformation, index) in homeQAInformationData.QAList" :key="index">
              <div class="col-12">
                <h4 class="question-title text-transform-none font-weight-bold">{{ QAInformation.TypeName }}</h4>
                <div class="question-qaqs" v-for="(info, infoIndex) in QAInformation.Children" :key="infoIndex">
                  <div class="item">
                    <div class="header">
                      <a v-b-toggle="'collapse' + index + infoIndex">{{info.Title}}</a>
                    </div>
                    <b-collapse class="content" :id="'collapse' + index + infoIndex">
                      <div v-html="info.Content"></div>
                    </b-collapse>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="homeProductInfo" class="homeSection" v-if="homeProductInfo">
          <h2 class="homeSection__heading homeProductInfo__heading" v-if="homeProductInfo.MasterTitle">{{homeProductInfo.MasterTitle}}</h2>
          <div class="homeSection__content">
            <b-tabs no-fade  v-model="homeProductInfoTabIndex" nav-class="homeProductInfo__tabs" nav-wrapper-class="homeProductInfo__nav-wrapper" content-class="homeProductInfo__tab-content" v-if="homeProductInfo.Content">
              <b-tab title-item-class="homeProductInfo__tab" title-link-class="homeProductInfo__nav-link" :title="productInfo.ProductType" v-for="(productInfo, index) in homeProductInfo.Content" :key="index">
                <div class="homeProductInfo__banner">
                  <div class="homeProductInfo__banner-wrapper">
                    <img class="homeProductInfo_img forPC" :src="productInfo.ImageDesktopBase64" alt="">
                    <img class="homeProductInfo__img forSP" :src="productInfo.ImageMobileBase64" alt="">
                    <a class="homeProductInfo__view-detail" :href="productInfo.PathDetail" :title="$t('viewDetailsProduct')">{{$t('viewDetailsProduct')}}
                      <i class="homeProductInfo__view-detail-icon">
                        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 31.49 31.49" style="enable-background:new 0 0 31.49 31.49;" xml:space="preserve"> <path fill="currentColor" d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111 C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587 c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z"/> </svg></i>
                    </a>
                    <div class="homeProductInfo__slogan">{{productInfo.Slogan}}</div>
                  </div>
                </div>
                <div class="homeProductInfo__header" v-b-toggle="'homeProductInfo__content-' + index"><span>{{$t('footer.productText')}}</span>{{productInfo.ProductType}}
                  <i class="homeProductInfo__header-icon">
                    <svg width="19px" height="11px" viewBox="0 0 19 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g id="Web-/-Mobile" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="[M]-4.0.0----Profile-/-Default-Copy-6" transform="translate(-308.000000, -509.000000)" fill="currentColor" fill-rule="nonzero"> <g id="Group-2-Copy-3" transform="translate(16.000000, 172.000000)"> <path d="M310.117699,337.000167 C309.888551,337.007319 309.672883,337.107447 309.514501,337.282672 L301.497704,345.79002 L293.480906,337.282672 C293.31747,337.105659 293.095062,337.005531 292.86086,337.005531 C292.510399,337.005531 292.195321,337.232608 292.063897,337.577694 C291.93079,337.92278 292.00998,338.317929 292.261032,338.577191 L300.887767,347.731799 C301.224749,348.0894 301.770659,348.0894 302.107641,347.731799 L310.734376,338.577191 C310.990482,338.316142 311.071357,337.91384 310.933195,337.565178 C310.796717,337.216516 310.473215,336.993015 310.117699,337.000167 Z" id="Path"></path> </g> </g> </g> </svg>
                  </i>
                </div>
                <b-collapse :id="'homeProductInfo__content-' + index" class="homeProductInfo__content">
                  <div class="homeProductInfo__content-item" v-for="(detailInfo, index) in productInfo.DetailInfo" :key="index">
                    <div class="homeProductInfo__content-item__title">{{detailInfo.Title}}</div>
                    <div class="homeProductInfo__content-item__content" v-html="detailInfo.Content"></div>
                  </div>
                  <a class="homeProductInfo__view-detail" :href="productInfo.PathDetail" :title="$t('viewDetailsProduct')">{{$t('viewDetailsProduct')}}
                    <i class="homeProductInfo__view-detail-icon">
                      <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 31.49 31.49" style="enable-background:new 0 0 31.49 31.49;" xml:space="preserve"> <path fill="currentColor" d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111 C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587 c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z"/> </svg></i>
                  </a>
                </b-collapse>
              </b-tab>
            </b-tabs>
          </div>
        </section>
        <section id="homeOtherInfo" class="homeSection" v-if="homeOtherInfo">
          <h2 class="homeSection__heading homeProductInfo__heading" v-if="homeOtherInfo.MasterTitle">{{homeOtherInfo.MasterTitle}}</h2>
          <div class="homeSection__content">
            <b-tabs no-fade v-model="homeOtherInfoTabIndex" nav-class="homeProductInfo__tabs" nav-wrapper-class="homeProductInfo__nav-wrapper" content-class="homeProductInfo__tab-content" v-if="homeOtherInfo.OtherInfo">
              <b-tab title-item-class="homeProductInfo__tab" title-link-class="homeProductInfo__nav-link" :title="otherInfo.Title" v-for="(otherInfo, index) in homeOtherInfo.OtherInfo" :key="index">
                <div class="homeProductInfo__banner">
                  <div class="homeProductInfo__banner-wrapper">
                    <img class="homeProductInfo_img forPC" :src="otherInfo.ImageDesktopBase64" alt="">
                    <img class="homeProductInfo__img forSP" :src="otherInfo.ImageMobileBase64" alt="">
                    <a class="homeProductInfo__view-detail" :href="otherInfo.PathDetail" :title="$t('viewDetailsProduct')">{{$t('viewDetailsProduct')}}
                      <i class="homeProductInfo__view-detail-icon">
                        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 31.49 31.49" style="enable-background:new 0 0 31.49 31.49;" xml:space="preserve"> <path fill="currentColor" d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111 C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587 c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z"/> </svg></i>
                    </a>
                    <div class="homeProductInfo__slogan">{{otherInfo.Slogan}}</div>
                  </div>
                </div>
                <div class="homeProductInfo__header" v-b-toggle="'homeOtherInfo__content-' + index"><span>{{$t('footer.productText')}}</span>{{otherInfo.Title}}
                  <i class="homeProductInfo__header-icon">
                    <svg width="19px" height="11px" viewBox="0 0 19 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g id="Web-/-Mobile" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="[M]-4.0.0----Profile-/-Default-Copy-6" transform="translate(-308.000000, -509.000000)" fill="currentColor" fill-rule="nonzero"> <g id="Group-2-Copy-3" transform="translate(16.000000, 172.000000)"> <path d="M310.117699,337.000167 C309.888551,337.007319 309.672883,337.107447 309.514501,337.282672 L301.497704,345.79002 L293.480906,337.282672 C293.31747,337.105659 293.095062,337.005531 292.86086,337.005531 C292.510399,337.005531 292.195321,337.232608 292.063897,337.577694 C291.93079,337.92278 292.00998,338.317929 292.261032,338.577191 L300.887767,347.731799 C301.224749,348.0894 301.770659,348.0894 302.107641,347.731799 L310.734376,338.577191 C310.990482,338.316142 311.071357,337.91384 310.933195,337.565178 C310.796717,337.216516 310.473215,336.993015 310.117699,337.000167 Z" id="Path"></path> </g> </g> </g> </svg>
                  </i>
                </div>
                <b-collapse :id="'homeOtherInfo__content-' + index" class="homeProductInfo__content">
                  <div class="homeProductInfo__content-item" v-for="(detailInfo, index) in otherInfo.OtherDetailInfo" :key="index">
                    <div class="homeProductInfo__content-item__title">{{detailInfo.Title}}</div>
                    <div class="homeProductInfo__content-item__content" v-html="detailInfo.Content"></div>
                  </div>
                  <a class="homeProductInfo__view-detail" :href="otherInfo.PathDetail" :title="$t('viewDetailsProduct')">{{$t('viewDetailsProduct')}}
                    <i class="homeProductInfo__view-detail-icon">
                      <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 31.49 31.49" style="enable-background:new 0 0 31.49 31.49;" xml:space="preserve"> <path fill="currentColor" d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111 C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587 c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z"/> </svg></i>
                  </a>
                </b-collapse>
              </b-tab>
            </b-tabs>
          </div>
        </section>
      </div>
    </div>
    <!-- End #Wrapper -->

    <!-- #Pre-footer -->
    <div id="pre-footer">
      <div id="main-content" class="container-fluid">
        <div class="row">
          <a id="footer-logo" class="d-none d-md-block col-md-2" href="javascript:void(0)">
            <img class="w-100" src="../assets/images/icon/footer-logo.svg" alt />
          </a>
          <div class="col-12 col-md-4">
            <h4 class="text-transform-none font-weight-bold">{{$t('footer.terms')}}</h4>
            <ul class="nav flex-column mb-4">
              <li class="nav-item mb-1">
                <b-link v-b-modal.informationSecurityPolicy><u>{{$t('footer.security_policy_btn')}}</u></b-link>
                <b-modal id="informationSecurityPolicy" size="lg" header-bg-variant="danger" centered header-text-variant="white" :title="$t('policyContentTitle')" scrollable>
                  <div v-html="$t('policyContent')">
                  </div>
                  <template v-slot:modal-footer="{ ok }">
                    <b-button size="lg" variant="danger" @click="ok()" block>OK</b-button>
                  </template>
                </b-modal>
              </li>
              <li class="nav-item">
                <b-link v-b-modal.termsOfUse><u>{{$t('footer.terms_btn')}}</u></b-link>
                <b-modal id="termsOfUse" size="lg" header-bg-variant="danger" centered header-text-variant="white" :title="$t('termsOfUseTitle')" scrollable>
                  <div v-html="$t('termsOfUseContent')">
                  </div>
                  <template v-slot:modal-footer="{ ok }">
                    <b-button size="lg" variant="danger" @click="ok()" block>OK</b-button>
                  </template>
                </b-modal>
              </li>
            </ul>
            <ul class="hd-social">
              <li>
                <a href="https://www.facebook.com/tfsvn" title="TFSVN - Tài Chính Toyota Việt Nam" target="_blank">
                  <i class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 112.196 112.196" style="enable-background:new 0 0 112.196 112.196;" xml:space="preserve"> <g> <circle style="fill:#3B5998;" cx="56.098" cy="56.098" r="56.098"/> <path style="fill:#FFFFFF;" d="M70.201,58.294h-10.01v36.672H45.025V58.294h-7.213V45.406h7.213v-8.34   c0-5.964,2.833-15.303,15.301-15.303L71.56,21.81v12.51h-8.151c-1.337,0-3.217,0.668-3.217,3.513v7.585h11.334L70.201,58.294z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>
                  </i>
                </a>
              </li>
              <li>
                <a href="https://www.youtube.com/channel/UCq9aEHtptfQbVdneuKO4PCw" title="TFSVN - Tài Chính Toyota Việt Nam" target="_blank">
                  <i class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#CD2900;" cx="256" cy="256" r="256"/> <path style="fill:#AB2400;" d="M256,0c-11.317,0-22.461,0.744-33.391,2.167C348.216,18.53,445.217,125.933,445.217,256  s-97.002,237.47-222.609,253.833C233.539,511.256,244.683,512,256,512c141.385,0,256-114.616,256-256S397.385,0,256,0z"/> <path style="fill:#FFFFFF;" d="M256,401.21c-53.823,0-108.152-3.063-161.476-9.105c-10.163-1.151-18.287-8.984-19.754-19.05  c-11.339-77.67-11.339-156.437-0.001-234.111c1.469-10.065,9.593-17.899,19.757-19.049c53.32-6.042,107.649-9.105,161.475-9.105  s108.154,3.063,161.476,9.105c10.163,1.151,18.287,8.984,19.754,19.049c11.339,77.672,11.339,156.438,0.001,234.112  c-1.469,10.065-9.593,17.898-19.755,19.049C364.152,398.146,309.823,401.21,256,401.21z"/> <path style="fill:#CD2900;" d="M207.22,182.98l130.473,68.531c3.617,1.9,3.617,7.079,0,8.979L207.22,329.021  c-3.377,1.773-7.428-0.676-7.428-4.489V187.469C199.791,183.656,203.844,181.206,207.22,182.98z"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>
                  </i>
                </a>
              </li>
            </ul>
          </div>
          <div class="col-12 col-md-6">
            <h4
              class="text-transform-none font-weight-bold"
            >{{$t('footer.companyName')}}</h4>
            <ul id="address" class="nav flex-column">
              <li
                class="nav-item location"
              >{{$t('footer.address')}}</li>
              <li class="nav-item phone">{{$t('footer.phone')}}</li>
              <li class="nav-item email">{{$t('footer.email')}}</li>
            </ul>

            <ul id="qcode" class="nav mt-3">
              <li class="nav-item mr-3 mb-3">
                <img src="../assets/images/icon/icon-qcode.svg" alt />
              </li>
              <li class="nav-item align-self-center">{{$t('footer.zalo')}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- #End Pre-footer -->

    <!-- End #Footer -->
    <div id="footer">
      <div id="main-content" class="container-fluid">
        <div class="row">
          <div class="col-12">
            <p
              class="copyright mt-4 mb-4 pt-2 pb-2"
            >{{ $t('footer.copyright') }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- End #Footer -->

    <div class="call-now-button" style="left: 47px; top: 75%;" v-if="showCallButton">
      <div>
        <p class="call-text"><a href="https://zalo.me/3767209184519268381" title="Chat Zalo"> Chat Zalo </a></p>
        <a href="https://zalo.me/3767209184519268381" title="Chat Zalo">
          <div class="quick-alo-ph-circle"></div>
          <div class="quick-alo-ph-circle-fill"></div>
          <div class="quick-alo-ph-btn-icon quick-alo-zalo-img-circle"></div>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import _ from 'lodash'
import axios from 'axios'
import { cacheAdapterEnhancer } from 'axios-extensions'
import { BootstrapVue } from 'bootstrap-vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueStickyDirective from '@renatodeleao/vue-sticky-directive'
import VueYoutube from 'vue-youtube'
import VueScrollTo from 'vue-scrollto'
import Slick from 'vue-slick'
import FlagIcon from 'vue-flag-icon'

Vue.use(BootstrapVue)
Vue.use(VueAwesomeSwiper)
Vue.use(VueStickyDirective)
Vue.use(VueYoutube)
Vue.use(VueScrollTo)
Vue.use(FlagIcon)

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Cache-Control': 'no-cache'
  },
  adapter: cacheAdapterEnhancer(axios.defaults.adapter)
})

export default {
  name: 'landingPage',
  components: {
    Slick
  },
  data () {
    return {
      languages: {
        en: [
          { flag: 'us', language: 'en', title: 'English' },
          { flag: 'vn', language: 'vn', title: 'Vietnamese' }
        ],
        vn: [
          { flag: 'us', language: 'en', title: 'Tiếng Anh' },
          { flag: 'vn', language: 'vn', title: 'Tiếng Việt' }
        ]
      },
      homeQAInformationData: {
        MasterTitle: '',
        QAList: null
      },
      homeQAInformationDataLoadDone: false,
      homeSlide: null,
      homeSlideLoadDone: false,
      homeProductInfo: null,
      homeProductInfoLoadDone: false,
      homeProductInfoTabIndex: 0,
      homePaymentGuide: null,
      homePaymentGuideLoadDone: false,
      homeBenefit: null,
      homeBenefitLoadDone: false,
      homeBenefitCurrentVideoID: '',
      homeBenefitCurrentVideoIndex: 0,
      homeBenefitHoverFlag: true,
      homeBenefitHoverActive: true,
      homeOtherInfo: null,
      homeOtherInfoLoadDone: false,
      homeOtherInfoTabIndex: 0,
      homeSlideSlickOptions: {
        infinite: true,
        dots: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 3000
      },
      swiperOptionThumbs: {
        loop: false,
        slidesPerView: 4,
        slideToClickedSlide: true
      },
      stickyOption: {
      },
      showCallButton: false
    }
  },
  methods: {
    ybClickHandle () {
      this.homeBenefitHoverActive = true
    },
    ybEndedHandle () {
      if (this.homeBenefitCurrentVideoIndex < this.homeBenefit.listVideo.length) {
        this.homeBenefitCurrentVideoIndex += 1
        this.homeBenefitCurrentVideoID = this.getVideoId(this.homeBenefit.listVideo[this.homeBenefitCurrentVideoIndex].VideoPath)
        setTimeout(() => {
          this.$refs.youtube.player.playVideo()
        }, 1000)
      }
    },
    homeBenefitClickHandle (index, reallyIndex) {
      index -= 1
      this.homeBenefitCurrentVideoIndex = index
      this.homeBenefitCurrentVideoID = this.getVideoId(this.homeBenefit.listVideo[index].VideoPath)
    },
    getVideoId (url) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
      const match = url.match(regExp)
      return (match && match[2].length === 11) ? match[2] : ''
    },
    homeSlideSlickHandleReInit () {
      this.$nextTick(() => {
        this.$refs.homeSlideSlick.reSlick()
      })
    },
    groupBy (array) {
      return _.uniqBy(array.map((a) => {
        return {
          Type: a.Type,
          TypeName: a.TypeName,
          Children: array.filter((b) => b.Type === a.Type)
        }
      }), 'Type')
    },
    changeLocale (locale) {
      this.$i18n.locale = locale
      this.fetchData()
    },
    fetchData () {
      httpClient
        .get('/QA/GetQAInformation', {
          params: {
            language: this.$i18n.locale
          }
        })
        .then(response => {
          this.homeQAInformationData.MasterTitle = response.data.data.MasterTitle
          this.homeQAInformationData.QAList = this.groupBy(response.data.data.QAList)
        })
        .finally(() => {
          this.homeQAInformationDataLoadDone = true
        })
      httpClient
        .get('/Home/GetSlide', {
          params: {
            language: this.$i18n.locale
          }
        })
        .then(response => {
          this.homeSlide = response.data.data
        })
        .finally(() => {
          this.homeSlideLoadDone = true
        })
      httpClient
        .get('/Home/GetProductInfo', {
          params: {
            language: this.$i18n.locale
          }
        })
        .then(response => {
          this.homeProductInfo = response.data.data
        })
        .finally(() => {
          this.homeProductInfoLoadDone = true
        })
      httpClient
        .get('/Home/GetPaymentGuide', {
          params: {
            language: this.$i18n.locale
          }
        })
        .then(response => {
          this.homePaymentGuide = response.data.data
        })
        .finally(() => {
          this.homePaymentGuideLoadDone = true
        })
      httpClient
        .get('/Home/GetBenefit', {
          params: {
            language: this.$i18n.locale
          }
        })
        .then(response => {
          this.homeBenefit = response.data.data
          this.homeBenefitCurrentVideoID = this.getVideoId(response.data.data.listVideo[this.homeBenefitCurrentVideoIndex].VideoPath)
        })
        .finally(() => {
          this.homeBenefitLoadDone = true
        })
      httpClient
        .get('/Home/GetOtherInfo', {
          params: {
            language: this.$i18n.locale
          }
        })
        .then(response => {
          this.homeOtherInfo = response.data.data
        })
        .finally(() => {
          this.homeOtherInfoLoadDone = true
        })
    }
  },
  mounted () {
    this.fetchData()
  },
  computed: {
    isLoading () {
      return (this.homeQAInformationDataLoadDone &&
              this.homeSlideLoadDone &&
              this.homeProductInfoLoadDone &&
              this.homePaymentGuideLoadDone &&
              this.homeBenefitLoadDone &&
              this.homeOtherInfoLoadDone)
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep {
    @import 'node_modules/bootstrap/scss/bootstrap';
    @import 'node_modules/bootstrap-vue/src/index.scss';
    @import '@/scss/components/_styles-landing-page.scss';
    .modal-dialog-scrollable .modal-body {
      max-height: 50vh;
    }
    .modal-dialog-centered.modal-dialog-scrollable {
      padding-top: 80px;
    }
    .modal-header {
      border-bottom: 0;
    }
    .header-spacing {
      display: none;
      width: 100%;
      height: 60px;
    }
    #header.is-affixed + .header-spacing {
      display: block;
    }
    .hd-social {
      display: flex;
      flex-wrap: wrap;
      a {
        display: block;
        transition: all 0.3s;
        &:hover {
          opacity: 0.75;
        }
      }
      li {
        margin-right: 5px;
        margin-bottom: 5px;
        &:last-child {
          margin-right: 0;
        }
      }
      .icon, .icon svg {
        width: auto;
        height: 30px;
      }
    }
  }
</style>
